import type { ActivityMessage } from "@/api/models"

export enum ActivityType {
  MESSAGE = "message",
  WEB_SEARCH = "web_search",
  WEB_SEARCH_RESULTS = "web_search_results",
  BROWSE_RESULTS = "browse_results",
  SEARCH_QUERY = "search_query",
  SEARCH_RESULTS = "search_results",
  TOOLS = "tools",
  IMAGE_GENERATED = "image_generated",
}

export type WebSearchResult = {
  type: ActivityType.WEB_SEARCH_RESULTS
  results: {
    title: string
    url: string
  }[]
}

export type SearchResult = {
  type: ActivityType.SEARCH_RESULTS
  results: {
    /** Indexed sourcefile basename — use for citation keys (library:title). */
    title: string
    library: string
    /** Original upload name when it differs from indexed title (UI label only). */
    display_title?: string
    snippet?: string
  }[]
}

export type ImageGeneratedResult = {
  type: ActivityType.IMAGE_GENERATED
  job_id?: string
  image_url: string
  revised_prompt?: string
  prompt: string
  is_edit?: boolean
  /** 0-100. Set on partial frames during streaming generation; 100 (or absent) means final. */
  progress?: number
  /** True while a streaming generation is still producing partial frames. */
  partial?: boolean
  /** Registry id of the image model that produced the image (#3038). */
  model_id?: string
  /** Display name of the image model, e.g. "GPT-Image 2.5 Flare" (#3038). */
  model_label?: string
  /**
   * Session file the tool persisted the image to (`image_<job>.png`). Lets a
   * reloaded page recover the image after `image_url` was stripped from the
   * stored activity (#3043).
   */
  session_file?: string
}

export type GroupedActivityMessage = {
  title: string
  activities: ActivityMessage[]
  agents: Array<{
    name?: string
    role?: string
    type?: string
    isLoading?: boolean
  }>
}
